import pathConstants from '../constants/pathConstants'

const pathUtils = {
  getContextPath: function (path) {
    let getContextPath = window['getContextPath']
    path = path || ''
    if (getContextPath) {
      return getContextPath() + path
    } else {
      return path
    }
  },
  getRootUrl: function (prop) {
    let location = window.location
    let protocol = prop ? prop.protocol || location.protocol : location.protocol
    let hostname = prop ? prop.hostname || location.hostname : location.hostname
    let port = prop ? prop.port || location.port : location.port
    let url = [protocol, '//', hostname]
    if (port) {
      switch (protocol) {
        case 'http':
          if (port !== 80) {
            url.push(':', port)
          }
          break
        case 'https':
          if (port !== 443) {
            url.push(':', port)
          }
          break
        default:
          url.push(':', port)
          break
      }
    }
    return url.join('')
  },
  isProtectedUrl: function (url) {
    return url && url.startsWith(pathConstants.PRO_RESOURCE_PREFIX)
  }
}

export default pathUtils
